export class RestoreGoogleWorkspaceRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "files",
            "baseName": "files",
            "type": "Array<FilePath>",
            "format": ""
        },
        {
            "name": "restoreMode",
            "baseName": "restoreMode",
            "type": "WorkspaceRestoreMode",
            "format": ""
        },
        {
            "name": "restoreTargetFolder",
            "baseName": "restoreTargetFolder",
            "type": "string",
            "format": ""
        },
        {
            "name": "preserveFolderHierarchy",
            "baseName": "preserveFolderHierarchy",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "restoreTargetMailboxes",
            "baseName": "restoreTargetMailboxes",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "restoreTargetLabel",
            "baseName": "restoreTargetLabel",
            "type": "string",
            "format": ""
        },
        {
            "name": "isGroup",
            "baseName": "isGroup",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "restoreTargetGroup",
            "baseName": "restoreTargetGroup",
            "type": "string",
            "format": ""
        },
        {
            "name": "restoreTargetDrive",
            "baseName": "restoreTargetDrive",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreGoogleWorkspaceRequest.attributeTypeMap;
    }
    constructor() {
    }
}
